/**
 * Scroll-reveal for the "How to use" section (#how-to).
 *
 * Two IntersectionObservers, deliberately split so they trigger differently:
 *   1. revealIO — fades/staggers each .reveal / .stagger block in *once*, early,
 *      as it enters from the bottom, so content is readable by the time you
 *      reach it. Does not reverse.
 *   2. lightIO — lights a step number when it rises above the viewport's
 *      vertical centre, and un-lights it (the glow reverses) when it drops back
 *      below on scroll-up. The rose "spine" fill tracks the lowest lit number,
 *      growing and receding with it. Keeps observing (never unobserves).
 *
 * Works for any number of steps (keyed off .step-num[data-step]).
 *
 * Reduced motion (or no IntersectionObserver): everything is shown at rest,
 * every circle lit, spine full — no animation.
 */
(function () {
  var section = document.getElementById('how-to');
  if (!section) return;

  var spine = section.querySelector('.walk__spine');
  var fill = section.querySelector('.walk__fill');
  var reveals = Array.prototype.slice.call(
    section.querySelectorAll('.reveal, .stagger')
  );
  var nums = Array.prototype.slice.call(
    section.querySelectorAll('.step-num[data-step]')
  );

  // Grow/recede the spine fill so it reaches the lowest currently-lit number.
  function updateFill() {
    if (!spine || !fill) return;
    var sr = spine.getBoundingClientRect();
    var h = 0;
    nums.forEach(function (c) {
      if (!c.classList.contains('is-lit')) return;
      var cr = c.getBoundingClientRect();
      var target = Math.max(0, cr.top - sr.top + cr.height / 2);
      if (target > h) h = target;
    });
    fill.style.height = h + 'px';
  }

  function setLit(circle, on) {
    if (circle.classList.contains('is-lit') === on) return;
    circle.classList.toggle('is-lit', on);
    updateFill();
  }

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) {
      el.classList.add('is-in');
    });
    nums.forEach(function (c) {
      c.classList.add('is-lit');
    });
    updateFill();
    return;
  }

  // 1. Fade content in early, once (does not reverse).
  var revealIO = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealIO.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
  );
  reveals.forEach(function (el) {
    revealIO.observe(el);
  });

  // 2. Light a number once it crosses above the viewport's vertical centre;
  //    un-light it when it drops back below (glow reverses on scroll-up). The
  //    rootMargin puts the trigger line at 50% of the viewport height, and we
  //    read the number's own position at each crossing to decide the state —
  //    so numbers scrolled off the top stay lit, while ones below stay dark.
  var lightIO = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var line = entry.rootBounds
          ? entry.rootBounds.bottom
          : window.innerHeight * 0.5;
        setLit(entry.target, entry.boundingClientRect.top < line);
      });
    },
    { rootMargin: '0px 0px -50% 0px', threshold: 0 }
  );
  nums.forEach(function (el) {
    lightIO.observe(el);
  });
})();
